/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  ProductDraftsUserControllerFindManyQueryResponse,
  ProductDraftsUserControllerFindManyQueryParams,
  ProductDraftsUserControllerFindMany401,
} from '../../types/ProductDraftsUserControllerFindMany.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { productDraftsUserFindMany } from '../../methods/productDraftsUserFindMany.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const productDraftsUserFindManyQueryKey = (params?: ProductDraftsUserControllerFindManyQueryParams) =>
  [{ url: '/api/user/product-drafts' }, ...(params ? [params] : [])] as const;

export type ProductDraftsUserFindManyQueryKey = ReturnType<typeof productDraftsUserFindManyQueryKey>;

export function productDraftsUserFindManyQueryOptions(
  params?: ProductDraftsUserControllerFindManyQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = productDraftsUserFindManyQueryKey(params);
  return queryOptions<
    ProductDraftsUserControllerFindManyQueryResponse,
    ResponseErrorConfig<ProductDraftsUserControllerFindMany401>,
    ProductDraftsUserControllerFindManyQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return productDraftsUserFindMany(params, config);
    },
  });
}

/**
 * {@link /api/user/product-drafts}
 */
export function useProductDraftsUserFindMany<
  TData = ProductDraftsUserControllerFindManyQueryResponse,
  TQueryData = ProductDraftsUserControllerFindManyQueryResponse,
  TQueryKey extends QueryKey = ProductDraftsUserFindManyQueryKey,
>(
  params?: ProductDraftsUserControllerFindManyQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ProductDraftsUserControllerFindManyQueryResponse,
        ResponseErrorConfig<ProductDraftsUserControllerFindMany401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? productDraftsUserFindManyQueryKey(params);

  const query = useQuery(
    {
      ...productDraftsUserFindManyQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<ProductDraftsUserControllerFindMany401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
